import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  sessionList: { sessions: [] },
  sessionTrialList: { sessionsTrial: [] },

  sessionsLoading: false,

  // TrialStartDate:null,
  // TrialExpiryDate:null,
  
  rewardsDetails:null,


  userDetails: {
    "Plan Name": null,
    "Total Sessions": null,
    "Expiry Date": null,
    Amount: null,
    Taxes: null,
    ogTotal: null,
    ogTaxes: null,
    "Total Amount": null,
    startdate: null,
    planid: null,
    sessionid: null,
    taxpercent: null,
    false_cost: null,
    couponcost: null,
    couponcode: null,
    couponid: null,
    userid: null,
    name: null,
    branchid: null,
    daystime: null,
    orderid: null,
    transactionid: null,
    transactionuid: null,
    email: null,
    phone: null,
    firstname: null,
    isTrial:null,

  },
  planName: null,

  startDateParam: null
 
};

const UrlSlice = createSlice({
  name: "UrlData",
  initialState: initialState,
  reducers: {
    sessionRed: (state, action) => {
      state.sessionList.sessions = action.payload;
    },

    userDetailAction: (state, action) => {
      state.userDetails.startdate = action.payload.startdate;
      state.userDetails["Plan Name"] = action.payload.planname;
      state.userDetails.planid = action.payload.planid;
      state.userDetails.sessionid = action.payload.sessionid;
      state.userDetails.Amount = action.payload.basecost;
      state.userDetails["Total Amount"] = action.payload.sumcost;
      state.userDetails.ogTaxes = action.payload.ogTaxes;
      state.userDetails.ogTotal = action.payload.ogTotal;
      state.userDetails.taxpercent = action.payload.taxpercent;
      state.userDetails.false_cost = action.payload.false_cost;
      state.userDetails.Taxes = action.payload.taxcost;
      state.userDetails.name = action.payload.name;
      state.userDetails["Expiry Date"] = action.payload.expirydate;
      state.userDetails["Total Sessions"] = action.payload.max_sessions;
      state.userDetails.branchid = action.payload.branchid;
      state.userDetails.daystime = action.payload.daystime;
      state.userDetails.isTrial = action.payload.isTrial;
    },

    couponDetailAction: (state, action) => {      
      state.userDetails.couponcost = action.payload.couponcost;
      state.userDetails.couponcode = action.payload.couponcode;
      state.userDetails.couponid = action.payload.couponid;
      state.userDetails.Discount = action.payload.Discount;      
      state.userDetails.Taxes = action.payload.Taxes;
      state.userDetails.ogTaxes = action.payload.ogTaxes;
      state.userDetails.ogTotal = action.payload.ogTotal;
      state.userDetails["Total Amount"] = action.payload.total;
    },

    coinsDetailAction: (state, action) => {
      state.userDetails.Taxes = action.payload.Taxes;
      state.userDetails.ogTaxes = action.payload.ogTaxes;
      state.userDetails.ogTotal = action.payload.ogTotal;
      state.userDetails["Total Amount"] = action.payload.total;
    },

    restCouponDetailAction: (state, action) => {
      state.userDetails.couponcost = null;
      state.userDetails.couponcode = null;
      state.userDetails.couponid = null;
      state.userDetails.Discount = null;      
      state.userDetails.Taxes = null;
      state.userDetails["Total Amount"] = null;
    },

    rewardsDataAction:(state, action)=>{
      state.rewardsDetails = action.payload;
      
    },
    
    PlanNameAction: (state, action) => {
      state.planName = action.payload;
    },
    FormPageAction: (state, action) => {
      state.userDetails.email = action.payload.email;
      state.userDetails.phone = action.payload.phone;
    },

    FormPageContactAction: (state, action) => {  
      state.userDetails.phone = action.payload;
    },

    TransactionAction: (state, action) => {
      state.userDetails.orderid = action.payload.orderid;
      state.userDetails.transactionid = action.payload.transactionid;
      state.userDetails.transactionuid = action.payload.transactionuid;
    },

    UseridAction: (state, action) => {
      state.userDetails.firstname = action.payload.firstname;
      state.userDetails.userid = action.payload.userid;
    },
    resetState(state, action) {
      return initialState;
    },

    sessionTrial: (state, action) => {
      state.sessionTrialList.sessionsTrial = action.payload;

    },

    starDateAction: (state, action) => {
      state.userDetails.startdate = action.payload;

    },

    endDateAction: (state, action) => {
      state.userDetails["Expiry Date"] = action.payload;
    },

    setSessionsLoading: (state, action) => {
      state.sessionsLoading = action.payload;
    },

    setStartDateParam: (state, action) => {
      state.startDateParam = action.payload;
    },



    // TrialDateAction:(state,action)=>{
    //   state.TrialStartDate = action.payload;
    //   // state.TrialStartDate["Expiry Date"] = action.payload;


    // }

  },
});

export const {
  sessionRed,
  userDetailAction,
  PlanNameAction,
  FormPageAction,
  TransactionAction,
  FormPageContactAction,
  UseridAction,
  sessionTrial,
  TrialDateAction,
  couponDetailAction,
  coinsDetailAction,
  rewardsDataAction,
  resetState,
  starDateAction,
  setSessionsLoading,
  setStartDateParam,
  restCouponDetailAction,
  endDateAction
} = UrlSlice.actions;
// export const resetState = () => ({
//   type: "mySlice/resetState",
// });
export const SweatReducer = UrlSlice.reducer;
